export default __webpack_public_path__ + "static/media/FSKoopman-LightItalic.ad243a13.woff";